<template>
  <div>
    <PageLayout>
      <template v-slot:header>
        <div class="ui padded grid">
          <div class="row">
            <div class="sixteen wide column">
              <Breadcrumb>
                <div class="active section">
                  <div class="neutral">Página inicial</div>
                </div>
              </Breadcrumb>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:main>
        <div class="ui padded grid">
          <div class="row">
            <div class="sixteen wide column">
              <div class="ui segment">
                <h3 class="ui header">
                  <i class="history icon"></i>
                  <div class="content">
                    Últimas atualizações
                    <div class="sub header">
                      O que mudou recentemente no sistema
                    </div>
                  </div>
                </h3>
                <div class="ui divider"></div>
                <div class="post" v-for="(post, index) in posts" :key="index">
                  <h4 class="ui header date-header">
                    {{ formatDate(post.date) }}
                  </h4>
                  <ul>
                    <li v-for="(entry, i) in post.entries" :key="i">
                      <span class="emoji" v-html="entry.emoji"></span
                      >{{ entry.description }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </PageLayout>
  </div>
</template>

<script>
import moment from 'moment';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';

const bugEmoji = '&#x1F41E;';
const partyEmoji = '&#x1F389;';

export default {
  name: 'home',
  components: { Breadcrumb, PageLayout },
  data() {
    return {
      // Resumo amigável das últimas alterações no eclub-api e no eclub-web,
      // agrupadas por data (mais recente primeiro).
      posts: [
        {
          date: '2026-10-09',
          entries: [
            {
              emoji: partyEmoji,
              description:
                'Relatório de Listagem de Contratos agora pode ser gerado em Excel: escolha o formato no novo campo "Formato". A planilha traz os filtros utilizados no cabeçalho e os contratos em uma lista contínua, sem paginação'
            }
          ]
        },
        {
          date: '2026-10-04',
          entries: [
            {
              emoji: partyEmoji,
              description:
                'Novo filtro "Quantidade de Parcelas em Atraso" (De/Até) nos relatórios de Cobranças e de Listagem de Contratos'
            }
          ]
        },
        {
          date: '2026-10-02',
          entries: [
            {
              emoji: partyEmoji,
              description:
                'Melhoria no envio e armazenamento da logo e da capa dos parceiros'
            },
            {
              emoji: partyEmoji,
              description:
                'Novo filtro "Tipo de Cancelamento" no Relatório de Listagem de Contratos: ao selecionar a situação "Cancelado", é possível filtrar os contratos cancelados automaticamente (por atraso de parcela) ou manualmente'
            },
            {
              emoji: bugEmoji,
              description:
                'Correção da data de cancelamento dos contratos cancelados automaticamente por atraso de parcela, que não estava sendo registrada'
            }
          ]
        },
        {
          date: '2026-07-10',
          entries: [
            {
              emoji: bugEmoji,
              description:
                'Correção de problema que impedia cadastrar o cartão de crédito ao criar o contrato e o assinante na mesma tela'
            }
          ]
        },
        {
          date: '2026-07-09',
          entries: [
            {
              emoji: bugEmoji,
              description:
                'Correção no envio de notificações de pagamento com cartão de crédito'
            },
            {
              emoji: bugEmoji,
              description:
                'Correção na busca por contratos e associados nos formulários de cadastro'
            }
          ]
        },
        {
          date: '2026-07-06',
          entries: [
            {
              emoji: partyEmoji,
              description:
                'Novo filtro no relatório de contratos para identificar assinantes que completam 1 ano dentro do mês'
            }
          ]
        },
        {
          date: '2026-07-02',
          entries: [
            {
              emoji: bugEmoji,
              description:
                'Correções de estabilidade no chat com Inteligência Artificial'
            }
          ]
        },
        {
          date: '2026-05-27',
          entries: [
            {
              emoji: partyEmoji,
              description:
                'Adicionado controle de permissões de acesso para relatórios'
            }
          ]
        },
        {
          date: '2026-05-15',
          entries: [
            {
              emoji: bugEmoji,
              description: 'Correção de campo no formulário de parcelas'
            }
          ]
        },
        {
          date: '2026-04-17',
          entries: [
            {
              emoji: bugEmoji,
              description: 'Correção no processo de autenticação de acesso'
            }
          ]
        },
        {
          date: '2026-04-10',
          entries: [
            {
              emoji: partyEmoji,
              description: 'Lançamento do chat com Inteligência Artificial'
            }
          ]
        },
        {
          date: '2026-04-08',
          entries: [
            {
              emoji: partyEmoji,
              description: 'Adicionada importação de pagamentos do SAAE'
            }
          ]
        }
      ]
    };
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD [de] MMMM [de] YYYY');
    }
  }
};
</script>
<style lang="css" scoped>
.post {
  padding-bottom: 2rem;
}
.date-header {
  text-transform: capitalize;
  color: rgba(0, 0, 0, 0.6);
}
ul {
  list-style: none;
}

ul li {
  margin-bottom: 10px;
}
.emoji {
  font-size: 1.4rem;
  margin-right: 10px;
}
</style>
